import { Controller } from '@hotwired/stimulus';
import { loadStripe } from '@stripe/stripe-js/pure';

export default class extends Controller {
  static targets = [
    'form',
    'button',
    'clientSecret',
    'email',
    'card',
    'errors',
    'spinner'
  ];
  static values = { publishableKey: String };

  async initialize() {
    this.handleCardError = this.handleCardError.bind(this);
    this.handleCheckout = this.handleCheckout.bind(this);
    this.publicKey = this.publishableKeyValue;
    this.stripe = await loadStripe(this.publicKey);
    this.options = {
      clientSecret: this.clientSecretTarget.value,
      appearance: {
        theme: 'stripe'
      }
    };
    this.elements = this.stripe.elements(this.options);
    this.paymentElement = this.elements.create('payment');
    this.paymentElement.mount(`#${this.cardTarget.getAttribute('id')}`);
    this.paymentElement.on('change', this.handleCardError);
    this.paymentElement.on('ready', () => {
      this.buttonTarget.classList.remove('hidden');
      this.spinnerTarget.classList.add('hidden');
    });

    this.paymentElement.on('error', (event) => {
      this.handleCardError(event);
    });
  }

  async handleCheckout(event) {
    event.preventDefault();
    const elements = this.elements;

    await this.stripe
      .confirmSetup({
        elements,
        confirmParams: {
          return_url: `${
            window.location.origin
          }/stripe/checkout?price=${this.data.get(
            'price'
          )}&tax=0&coach=${this.data.get('coach')}`
        }
      })
      .then((result) => {
        if (result.error) {
          this.handleCardError(event);
        }
      });
  }

  handleCardError(event) {
    if (event.error) {
      this.errorsTarget.classList.add('py-2');
      this.errorsTarget.textContent = event.error.message;
    } else {
      this.errorsTarget.classList.remove('py-2');
      this.errorsTarget.textContent = '';
    }
  }
}
